"use client"
import { Col, Container, Row } from "react-bootstrap"
import Link from "next/link"

export default function ProfessionalInfo() {
  return (
    <Container>
      <div className="mh-90 d-flex align-items-center justify-content-center">
        <Row className="w-100">
          <Col
            sm={12}
            md={12}
            lg={{ span: 8, offset: 2 }}
          >
            <p>
              Here's your <strong><i>Exclusive Opportunity</i></strong>!
            </p>
            <p>
              Nearly one billion people worldwide are estimated to suffer from some form of mental disorder. MindBalance.net offers a unique and highly beneficial opportunity for professionals in the healthcare industry.
            </p>

            <p className="mb-2">
              You'll pay only <strong>$49</strong> per month (no long term contract) to experience:
            </p>
            <ul className="ps-5">
              <li>
                Exclusive access to all the leads generated by Mind Balance visitors seeking professionals in your location and specialty
              </li>
              <li>
                Potential customers will go to a web destination you select
              </li>
              <li>
                Not just a lead generation tool; it's a bridge connecting you directly to individuals actively seeking your expertise and services
              </li>
              <li>
                Gauge the effectiveness of the services without prolonged commitment
              </li>
            </ul>

            <p className="mb-5">
              <Link href="/professional-signup" className="me-2">
                Click here
              </Link>
              to secure your spot as the only professional in your city, category  and specialty
            </p>

            <div className="pt-5">
              <p className="mb-0">
                By continuing, you agree to our terms of service and privacy policy
              </p>
              <p>
                Do you already have an account?
                <Link href="/login" className="ms-2">
                  Sign in
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  )
}
